import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { AuthenticateService, RegisteredUserService } from '@app/api/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModalForgotPasswordComponent } from '../modal-forgot-password/modal-forgot-password.component';
// Auth
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/reducers';
import { environment } from 'environments/environment';
import { ModalSignUpSuccessComponent } from '../modal-sign-up-success/modal-sign-up-success.component';
import { AuthService, Login } from '@app/core/auth';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'meu-modal-create-sign-in-up',
  templateUrl: './modal-create-sign-in-up.component.html',
  styleUrls: ['./modal-create-sign-in-up.component.scss'],
})
export class ModalCreateSignInUpComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ModalCreateSignInUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private authenticateService: AuthenticateService,
    private toastr: ToastrService,
    private registeredUserService: RegisteredUserService,
    private dialog: MatDialog,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService
  ) {}
  private returnUrl: any;
  signupForm = new FormGroup({
    fullname: new FormControl('', [
      Validators.required,
      Validators.pattern('^[^\\s][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\\]]*$'),
    ]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$'),
    ]),
    company_name: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z]{2,4}$'),
    ]),
    password: new FormControl('', [
      Validators.required,
      Validators.pattern('^(?!\\s*$).+'),
      Validators.minLength(3),
    ]),
    is_company: new FormControl(false, [Validators.required]),
  });
  // Zalo test simplified form (separate tab)
  zaloTestForm = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '(^([+]?\\d[\\d\\s()\\-]{6,}$)|(^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$))'
      ),
    ]),
    full_name: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(3)]),
  });
  signinForm = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    password: new FormControl('', [
      Validators.required,
      Validators.pattern('^(?!\\s*$).+'),
      Validators.minLength(3),
    ]),
  });
  userInfoForm = new FormGroup({
    full_name: new FormControl(''),
    phone: new FormControl(''),
    company_name: new FormControl(''),
    email: new FormControl(''),
    password: new FormControl(''),
    is_company: new FormControl(''),
  });
  isShow: boolean = false;
  isShowAccountType = '';
  loading = false;
  indexTab: any = 0;
  isLoginError: boolean = false;
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params.returnUrl || '/';
    });
    if (!this.signupForm.value.is_company) {
      this.isShowAccountType = 'showUser';
    }
    if (this.data.type == 'signup') {
      this.indexTab = 1;
    }

    if (this.data.returnUrl) {
      this.returnUrl = this.data.returnUrl;
    }

    this.signupForm.get('phone').valueChanges.subscribe((val) => {
      const cleaned = (val || '').replace(/\s/g, '');
      if (cleaned !== val) {
        this.signupForm.get('phone').setValue(cleaned, { emitEvent: false });
      }
    });
  }
  showHiddenPass() {
    this.isShow = !this.isShow;
  }
  closeModal() {
    this.dialogRef.close(true);
  }
  signIn() {
    const controls = this.signinForm.controls;
    if (this.signinForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.authenticateService
      .apiAuthenticateAuthenticatePost(
        this.signinForm.value.username.trim(),
        this.signinForm.value.password.trim()
      )
      .subscribe((res) => {
        console.log('[AUTH] Login response:', JSON.stringify(res));
        if (res && res.success) {
          const token =
            res.token ||
            (res.data && res.data.token) ||
            res.authToken ||
            res.accessToken ||
            (res.data && res.data.authToken) ||
            (res.data && res.data.accessToken);
          
          console.log('[AUTH] Token extracted:', token ? 'YES' : 'NO');
          
          if (!token) {
            console.error('[AUTH] Token not found in response keys:', Object.keys(res), res.data ? Object.keys(res.data) : 'no data');
            this.isLoginError = true;
            return;
          }
          // 1. Save token vào localStorage
          localStorage.setItem(environment.authTokenKey, token);
          console.log('[AUTH] ✅ Token saved to localStorage');
          // 2. Close dialog trước
          this.dialogRef.close({ event: true, type: 'signin' });
          // 3. Reload trang để init$ đọc token → load user + roles từ JWT
          // Đảm bảo toàn bộ header/components cập nhật đúng trạng thái đăng nhập
          window.location.reload();
        } else {
          console.log('[AUTH] ❌ Login failed:', res);
          this.isLoginError = true;
        }
      });
  }
  signUp() {
    if (!this.signupForm.value.is_company) {
      this.signupForm.patchValue({
        company_name: 'company_name',
      });
      this.userInfoForm.value.email = this.signupForm.value.email;
      this.userInfoForm.value.company_name = '';
    } else {
      this.userInfoForm.value.company_name = this.signupForm.value.company_name;
      this.userInfoForm.value.email = this.signupForm.value.email.trim();
    }
    const controls = this.signupForm.controls;
    if (this.signupForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.userInfoForm.value.phone = this.signupForm.value.phone;
    this.userInfoForm.value.password = this.signupForm.value.password;
    this.userInfoForm.value.is_company = this.signupForm.value.is_company;
    this.userInfoForm.value.full_name = this.signupForm.value.fullname;
    this.registeredUserService.apiRegisteredUsersPost(this.userInfoForm.value).subscribe((res) => {
      if (res.success) {
        this.dialogRef.close({ event: true, type: 'signup' });
        this.dialog.open(ModalSignUpSuccessComponent, {
          width: '460px',
          data: { email: this.userInfoForm.value.email },
        });
      } else {
        this.toastr.error(res.message, '', {
          positionClass: 'toast-center-center',
        });
      }
    });
  }

  // Handler for Zalo Test tab: send only username, password, full_name to apiRegistrationsPost
  signUpZaloTest() {
    const controls = this.zaloTestForm.controls;
    if (this.zaloTestForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    const payload = {
      username: (this.zaloTestForm.value.username || '').trim(),
      password: (this.zaloTestForm.value.password || '').trim(),
      full_name: (this.zaloTestForm.value.full_name || '').trim(),
    };
    this.registeredUserService.apiRegistrationsPost(payload).subscribe((res) => {
      if (res && res.success) {
        this.dialogRef.close({ event: true, type: 'signup' });
        this.dialog.open(ModalSignUpSuccessComponent, {
          width: '460px',
          data: { email: payload.username },
        });
      } else {
        this.toastr.error(res && res.message ? res.message : 'Đăng ký thất bại', '', {
          positionClass: 'toast-center-center',
        });
      }
    });
  }
  showEmailUserOrEmailCompany() {
    this.signupForm.patchValue({
      company_name: '',
    });
    if (!this.signupForm.value.is_company) {
      this.isShowAccountType = 'showUser';
    }
    if (this.signupForm.value.is_company) {
      this.isShowAccountType = 'showCompany';
    }
  }
  openModalForgotPassword() {
    const dialogRef = this.dialog.open(ModalForgotPasswordComponent, {
      width: '450px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        if (result.event) {
          this.dialogRef.close(true);
          this.dialog.open(ModalForgotPasswordComponent, {
            width: '460px',
            data: {
              isShowChange: true,
              emailName: result.emailName,
            },
          });
        }
      }
    });
  }

  hideErrorPopup() {
    this.isLoginError = false;

    this.signinForm.markAsUntouched();
  }

  openModalForgotPasswordFromError() {
    this.hideErrorPopup();
    this.openModalForgotPassword();
  }
}
